import { API, API_BASE } from '../config/api';
import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';


function getFanId() {
  let id = localStorage.getItem('melodrop_fan_id');
  if (!id) {
    id = 'fan_' + Math.random().toString(36).substring(2) + Date.now().toString(36);
    localStorage.setItem('melodrop_fan_id', id);
  }
  return id;
}

export default function FireButton({ itemType, itemId, size = 'sm' }) {
  const [fired, setFired] = useState(false);
  const [count, setCount] = useState(0);
  const [animating, setAnimating] = useState(false);
  const fanId = getFanId();

  useEffect(() => {
    axios.get(`${API}/likes/${itemType}/${itemId}?fan_id=${fanId}&reaction_type=fire`)
      .then(r => { setFired(r.data.liked); setCount(r.data.count); })
      .catch(() => {});
  }, [itemType, itemId, fanId]);

  const toggle = useCallback(async (e) => {
    e.stopPropagation();
    e.preventDefault();
    setAnimating(true);
    const newFired = !fired;
    setFired(newFired);
    setCount(prev => newFired ? prev + 1 : Math.max(0, prev - 1));
    try {
      const { data } = await axios.post(`${API}/likes`, {
        item_type: itemType, item_id: itemId, fan_id: fanId, reaction_type: 'fire'
      });
      setFired(data.liked);
      setCount(data.count);
    } catch {
      setFired(!newFired);
      setCount(prev => newFired ? Math.max(0, prev - 1) : prev + 1);
    }
    setTimeout(() => setAnimating(false), 700);
  }, [fired, itemType, itemId, fanId]);

  const iconSize = size === 'lg' ? 'w-6 h-6' : size === 'md' ? 'w-5 h-5' : 'w-4 h-4';
  const textSize = size === 'lg' ? 'text-sm' : 'text-xs';

  return (
    <button
      onClick={toggle}
      className={`group flex items-center gap-1.5 transition-all duration-300 ${fired ? 'text-[#F97316]' : 'text-[#666] hover:text-[#F97316]/70'}`}
      data-testid={`fire-btn-${itemType}-${itemId}`}
      title={fired ? 'Remove DAAS HOT!' : 'DAAS HOT!'}
    >
      <span className={`relative ${iconSize} ${animating ? 'fire-burst' : ''}`}>
        {fired ? (
          <svg viewBox="0 0 24 24" fill="currentColor" className="w-full h-full drop-shadow-[0_0_8px_rgba(249,115,22,0.6)]">
            <path d="M12 23c-3.6 0-8-2.4-8-7.5 0-4 3-7.5 4-9.5.3-.6 1.2-.4 1.2.3 0 1.7 1.3 3.2 2.3 3.2.7 0 .7-.6.5-1.5-.3-1.3-.5-3-.5-4.5 0-1.5.8-2.8 1.8-3.3.4-.2.9.1.8.6-.3 2.2.7 4.2 2.4 5.2.5.3 1-.2 1-.8 0-.8.3-1.7.8-2.4.3-.4.9-.3 1.1.2C20.5 6 21 8.5 21 10.5c0 5-3.6 7.5-5 8.5-1 .7-2.3 1.8-4 4z"/>
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="w-full h-full">
            <path d="M12 23c-3.6 0-8-2.4-8-7.5 0-4 3-7.5 4-9.5.3-.6 1.2-.4 1.2.3 0 1.7 1.3 3.2 2.3 3.2.7 0 .7-.6.5-1.5-.3-1.3-.5-3-.5-4.5 0-1.5.8-2.8 1.8-3.3.4-.2.9.1.8.6-.3 2.2.7 4.2 2.4 5.2.5.3 1-.2 1-.8 0-.8.3-1.7.8-2.4.3-.4.9-.3 1.1.2C20.5 6 21 8.5 21 10.5c0 5-3.6 7.5-5 8.5-1 .7-2.3 1.8-4 4z"/>
          </svg>
        )}
      </span>
      {count > 0 && <span className={`${textSize} font-mono font-bold`}>{count}</span>}

      <style>{`
        @keyframes fireBurst {
          0% { transform: scale(1) rotate(0deg); }
          20% { transform: scale(1.5) rotate(-10deg); }
          40% { transform: scale(0.85) rotate(5deg); }
          60% { transform: scale(1.25) rotate(-3deg); }
          80% { transform: scale(1.05) rotate(1deg); }
          100% { transform: scale(1) rotate(0deg); }
        }
        .fire-burst { animation: fireBurst 0.6s ease-out; }
      `}</style>
    </button>
  );
}
